import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import {
  DEFAULT_LANDING_PATH,
  ModuleKey,
  RoleAccess,
  canAccessModule,
  canAccessPath,
  filterSidebarSections,
  getMesLandingPath,
  getRoleAccess,
} from "../constants/roleAccess";

type ModuleAccess = {
  access: RoleAccess | null;
  /** False when the role sees the whole app. */
  isRestricted: boolean;
  landingPath: string;
  mesLandingPath: string;
  canAccessModule: (module: ModuleKey) => boolean;
  canAccessPath: (pathname: string) => boolean;
  filterSidebarSections: (sections: any[]) => any[];
};

/** Resolves what the signed-in user's role is allowed to see. */
export function useModuleAccess(): ModuleAccess {
  const { userRoleId } = useAuth();

  return useMemo(() => {
    const access = getRoleAccess(userRoleId);
    return {
      access,
      isRestricted: access !== null,
      landingPath: access?.landingPath ?? DEFAULT_LANDING_PATH,
      mesLandingPath: getMesLandingPath(access),
      canAccessModule: (module: ModuleKey) => canAccessModule(access, module),
      canAccessPath: (pathname: string) => canAccessPath(access, pathname),
      filterSidebarSections: (sections: any[]) =>
        filterSidebarSections(sections, access),
    };
  }, [userRoleId]);
}

export default useModuleAccess;
